exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-wrapper[data-v-12088817]{background:#fff;border-radius:14px;border:1px solid #e9eceb;-webkit-box-shadow:0 6px 20px rgba(0,0,0,.05);box-shadow:0 6px 20px rgba(0,0,0,.05);overflow:hidden;margin-bottom:20px;padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12088817","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/js/components/fields/Preview.vue
// module id = jUOJ
// module chunks = 0 1